import { useMutation } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import mutationServiceOptionsToTQMutationOptions, { MutationOptions } from 'services/tq-adapter/mutationServiceOptionsToTQMutationOptions';
import mutationServiceToTQMutationFunction from 'services/tq-adapter/mutationServiceToTQMutationFunction';
import { OneMutationService } from 'types/services/services';

/**
 * Provide the ability to use a mutation service.
 * @param service mutation service to use
 * @param opts options of the mutation service
 * @returns mutate service usage interface
 */
const useMutationService = <Data, Params = undefined>(service: OneMutationService<Data, Params>, opts?: MutationOptions<Data, Params>) => {
  const dispatch = useDispatch();
  const mutationFn = useMemo(() => mutationServiceToTQMutationFunction(service, dispatch), [dispatch, service]);
  const options = useMemo(() => mutationServiceOptionsToTQMutationOptions(service, opts), [service, opts]);

  return useMutation({ mutationFn, ...options });
};

export default useMutationService;
